import React from "react";
import ReactDOM from "react-dom";
import {
	Route,
	RouterProvider,
	createBrowserRouter,
	createRoutesFromElements,
} from "react-router-dom";
import { Courses } from "./pages/Courses/Courses";
import LessonsListing from "./pages/LessonsListing/LessonsListing";
import "./index.css";
import { Provider } from "react-redux";
import { persistor, store } from "../src/app/store";
import LessonDetails from "./pages/LessonDetails/LessonDetails";
import "rsuite/dist/rsuite.min.css";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";
import { PersistGate } from "redux-persist/integration/react";
import { LanguageProvider, PointsProvider } from "../src/app/context";
import { GameProvider } from "./app/context/GameContext";
import { AuthenticatedRoute } from "./app/routing/AuthenticatedRoutes";
import { RedirectedRoute } from "./app/routing/RedirectedRoutes";
import { AboutMe } from "./pages/AboutMe/AboutMe";
import ActivityPage from "./pages/ActivityPage/ActivityPage";
import { BlogDetail } from "./pages/Blog/BlogDetails/BlogDetails";
import { BlogPage } from "./pages/Blog/BlogsListing";
import { Games } from "./pages/Games/Games";
import { GamesList } from "./pages/Games/components/GamesList/GamesList";
import { LandingPage } from "./pages/LandingPage/LandingPage";
import { LeadersBoard } from "./pages/LeadersBoard/LeadersBoard";
import { LoginPage } from "./pages/LoginPage/LoginPage";
import { RegisterPage } from "./pages/RegisterPage/RegisterPage";
import StudentProfile from "./pages/StudentProfile/StudentProfile";
import { Navigation } from "./shared/components/Navigation/Navigation";

const isMobile =
	/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
		navigator.userAgent,
	);
const Backend = isMobile ? TouchBackend : HTML5Backend;

const App = () => {
	const router = createBrowserRouter(
		createRoutesFromElements(
			<>
				<Route element={<RedirectedRoute />}>
					<Route path="/" element={<LandingPage />} />
					<Route path="/login" element={<LoginPage />} />
					<Route path="/register" element={<RegisterPage />} />
				</Route>
				<Route path="/" element={<Navigation />}>
					<Route path="/courses" element={<Courses />} />
					<Route path="/games" element={<Games />} />
					<Route path="/leadersboard" element={<LeadersBoard />} />
					<Route path="/blog" element={<BlogPage />} />
					<Route path="/blog/:id" element={<BlogDetail />} />
					<Route path="/about" element={<AboutMe />} />
					<Route element={<AuthenticatedRoute />}>
						<Route path="/courses/:id" element={<LessonsListing />} />
						<Route path="/profile" element={<StudentProfile />} />
						<Route path="/lessons/:id" element={<LessonDetails />} />
						<Route path="/activity/:id" element={<ActivityPage />} />
						<Route path="/games/:activityType" element={<GamesList />} />
					</Route>
				</Route>
			</>,
		),
	);

	return (
		<GameProvider>
			<LanguageProvider>
				<PointsProvider>
					<div className="App">
						<PersistGate persistor={persistor} loading={null}>
							<DndProvider
								backend={Backend}
								options={{ enableMouseEvents: true }}
							>
								<Provider store={store}>
									<RouterProvider router={router} />
								</Provider>
							</DndProvider>
						</PersistGate>
					</div>
				</PointsProvider>
			</LanguageProvider>
		</GameProvider>
	);
};

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
